import React, {Component} from 'react'
import {connect} from "react-redux"
import propTypes from 'prop-types'
import iconNames from 'theme/icons'
import {getColumnDefinition} from './columnDefinition'
import EditablePivotTable from "containers/editablePivotTable"
import Icon from "components/icon"
import {requestData} from "actions/pivotTable"
import {deleteTrustedDevice} from "actions/settings"
import {prefix} from "helpers/component"
import './trustedDevicesPivotTable.scss'
import './trustedDevicesPivotTable.scss'

export const trustedDevicesPivotTableKey = 'settingsContext.trustedDevice.pivotTable'
const getClass = prefix('trustedDevicePivotTable-')

class TrustedDevicesPivotTable extends Component {

  componentDidMount() {
    const {onLoadTrustedDevices} = this.props
    if (onLoadTrustedDevices) {
      onLoadTrustedDevices()
    }
  }

  onDeleteTrustedDevice = (device) => {
    const {deleteTrustedDevice} = this.props
    deleteTrustedDevice(device)
  }

  render() {
    const columns = getColumnDefinition()
    const controlColumn = [{
      key: 'icon',
      label: '',
      size: 60,
      onGetContent: ({}) => {
        return <div className={getClass('icon')}>
          <Icon name={iconNames.laptop} size={35}/>
        </div>
      },
    }]

    return (
      <EditablePivotTable
        actions={[]}
        allowDelete={true}
        singularNoun={'Trusted Device'}
        pluralNoun={'Trusted Devices'}
        allowBulkEdit={false}
        sortingAllowed={false}
        showHeader={false}
        pagingAllowed={false}
        columnSelectAllowed={false}
        hideFixedRowAddButtonWhilstAdding={true}
        editBeforePersist={false}
        showReloads={false}
        stateKey={trustedDevicesPivotTableKey}
        columns={columns}
        onDeleteEntity={this.onDeleteTrustedDevice}
        controlColumns={controlColumn}
        icon={iconNames.approvals}
        showAdd={true}
        stickyTop={0}
      />
    )
  }
}

TrustedDevicesPivotTable.propTypes = {
  onLoadTrustedDevices: propTypes.func,
  deleteTrustedDevice: propTypes.func,
}

const mapDispatchToProps = (dispatch) => {
  return {
    onLoadTrustedDevices: () => dispatch(requestData(trustedDevicesPivotTableKey)),
    deleteTrustedDevice: (device) => dispatch(deleteTrustedDevice(device)),
  }
}

export default connect(null, mapDispatchToProps)(TrustedDevicesPivotTable)
